/** 결과 화면에서 공유하는 도메인 표시 규칙. 시각 토큰과 계산 규칙을 섞지 않는다. */
export const RESULT_SHARE_MAX_SEGMENTS = 6;
export const RESULT_SHARE_MIN_VISIBLE_PERCENT = 2;
